export default __webpack_public_path__ + "media/images/passive_house-c8149593cc9785f9ded9eb592e1b146a.png";